export const stripNonNumericCharacters = (input: string): string => {
  const value = input.replace(/\D/g, '');

  if (value.length > 16) {
    return value.slice(0, 16);
  }

  return value;
};
